import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../utils/supabaseClient';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children
}) => {
  const {
    isAuthenticated,
    user
  } = useAuth();
  useEffect(() => {
    // Set up auth state change listener to handle resuming course progress
    if (isAuthenticated && user) {
      const setupProgressListener = async () => {
        const {
          data: progress
        } = await supabase.from('progress').select('course_id, last_module').eq('user_id', user.id).order('updated_at', {
          ascending: false
        }).limit(1).single();
        // Store most recent progress in local storage for quick access
        if (progress) {
          localStorage.setItem('lastProgress', JSON.stringify(progress));
        }
      };
      setupProgressListener();
    }
  }, [isAuthenticated, user]);
  if (!isAuthenticated) {
    return <Navigate to="/login" data-id="element-55" />;
  }
  return <>{children}</>;
};
export default ProtectedRoute;